import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function TeamSection() {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 max-w-3xl mx-auto">
          <p className="eyebrow justify-center mb-3">
            <Link to="/about#team">Our Global Team</Link>
          </p>
          <h2 className="section-title mb-6">
            OVER 600 PROFESSIONALS WORLDWIDE <br />
            DEDICATED TO EXCELLENCE
          </h2>
          <p className="text-gray-600 mb-8">
            Our team consists of over 600 highly skilled professionals operating in more than 135 countries.
            From airport concierge specialists to expert chauffeurs and dedicated customer support agents,
            we ensure seamless travel experiences across the globe. No matter where you are, our team is
            ready to serve you with precision, efficiency, and a touch of luxury.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/about">
              <button className="btn-primary w-full sm:w-auto">
                Learn More About Us <ChevronRight size={18} />
              </button>
            </Link>
            <Link to="/contact">
              <button className="btn-outline w-full sm:w-auto">
                Get in Touch <ChevronRight size={18} />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TeamSection;
